import { useEffect } from "react";
import AWS from "aws-sdk";
import { formatFileSize } from "../utils/FileUtils";

const S3_BUCKET = 'karmabox-temp';
const REGION = 'ap-south-1';
// const ACCESS_KEY = process.env.AWS_ACCESS_KEY;
// const SECRET_ACCESS_KEY = process.env.AWS_SECRET_ACCESS_KEY;
const ACCESS_KEY = 'AKIAUBEI7Y2FX4THBDUO';
const SECRET_ACCESS_KEY = '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';

AWS.config.update({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
  region: REGION,
});

const s3 = new AWS.S3();

const CustomUploader = (props) => {

  useEffect(() => {
    if (props.currentFile?.file && !props.currentFile.uploaded && !props.currentFile.uploading) {
      props.setProgress(0);
      handleUpload(props.currentFile);
    }
  }, [props.currentFile]);

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const ext = file.name.split('.').pop().toLowerCase();
    if (props.validFileTypes && !props.validFileTypes.includes(ext)) {
      props.onUploadErrorCallback?.("Unsupported file format. Please upload a csv or excel file.");
      return;
    }
    const tmpFile = {
      file: new Blob([file], { type: file.type }),
      name: file.name.replace(/[^\w\.]/g, ""),
      extension: ext,
      uploaded: false,
      uploadedUrl: null,
      size: formatFileSize(file.size)
    };
    props.setCurrentFile(tmpFile);
  };

  const handleUpload = (fileObj) => {
    props.onUploadBeginCallback?.();
    const params = {
      Bucket: S3_BUCKET,
      Key: `prod/${Date.now()}_${fileObj.name}`,
      Body: fileObj.file,
      ACL: "public-read",
    };

    s3.upload(params)
      .on("httpUploadProgress", (evt) => {
        const prog = Math.round((evt.loaded / evt.total) * 100);
        props.setProgress(prog);
      })
      .send((err, data) => {
        if (err) {
          props.onUploadErrorCallback?.();
        } else {
          setTimeout(() => {
            props.onUploadFinishCallback?.({
              ...fileObj,
              uploaded: true,
              uploadedUrl: data.Location,
            });
          }, props.uploadFinishDelay ?? 3000);
        }
      });
  };

  return (
    <div className="custom-uploader__hidden">
      <input type="file" onChange={handleFileInput} ref={props.isRefedTo} />
    </div>
  );
};

export default CustomUploader;